import React from 'react'
import { css } from '@emotion/core'
import { Separator, H2, Paragraph } from '@fs/zion-ui'
import LocationImage from '@fs/zion-location-image'
import { useTranslation } from 'react-i18next'

const countriesContainerCss = (wrapMaps) => css`
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  flex-wrap: ${wrapMaps ? 'wrap' : 'nowrap'};
  gap: ${wrapMaps ? '30px' : '10px'};
`
// Zion colors: colors.green40, colors.green30, colors.green20
const countryColors = ['#679a1e', '#83af1d', '#a7c41a']
export default function SurnameCountries({ surname = '', countries = [], wrapMaps = false }) {
  const [t] = useTranslation()

  return (
    <div css={countriesContainerCss(wrapMaps)}>
      {wrapMaps && (
        <H2 size="H6" centered>
          {t('SurnameCountries.surname.label', '{surname} is most likely found in:', { surname })}
        </H2>
      )}
      <Separator />
      {countries.map((country, i) => (
        <div key={country.name}>
          <LocationImage
            isoCode={country.code}
            color={countryColors[i]}
            height={wrapMaps ? '175px' : '100px'}
            width={wrapMaps ? '75px' : '50px'}
            title={country.name}
          />
          <H2 size="H6" centered>
            {country.name}
          </H2>
          <Separator size="nano" />
          <Paragraph centered size="xs" balanced>
            {t('SurnameCountries.surnameNumInCountry.label', '{count} people in Family Tree', {
              count: country.count?.toLocaleString(),
              lineBreak: <br />, // Used for Chinese to split count and description on to different lines
            })}
          </Paragraph>
        </div>
      ))}
    </div>
  )
}
